export function getDeviceHostName() {
    return 'unknown';
}
